import React from "react";

import {
    InsuranceHeroBanner,
    InsuranceOverviewwidget,
    InsurancePlansCards,
    InsurancePlanBenifits,
    InsuranceTaxBenifits,
    InsurancePlanPricingCards,
    InsuranceBenifitsSummary,
    InsuranceOfferSummary,
    InsuranceRelatedSearchSummary,
    InsuranceDisclaimerFooter,
} from "pageComponents/insurance";

import SEO from "components/seo";

import Layout from "components/Layout/Layout";
const Insurance = () => (
    <Layout showFooter={false}>
        <SEO
            title="Insurance Policy Online: Buy Life, Health, Motor &amp; Travel Insurance | PhonePe"
            description="Buy or Renew Insurance Policy online on PhonePe  - Life, Health, Motor and Travel Insurance. Understand different types of insurance plans with process to buy and claim on PhonePe."
            url="https://www.phonepe.com/insurance/"
        />
        <InsuranceHeroBanner />
        <InsuranceOverviewwidget />
        <InsurancePlansCards />
        <InsurancePlanBenifits />
        <InsuranceTaxBenifits />
        <InsurancePlanPricingCards />
        <InsuranceBenifitsSummary />
        <InsuranceOfferSummary />
        <InsuranceRelatedSearchSummary />
        <InsuranceDisclaimerFooter />
    </Layout>
);

export default Insurance;
